import React from 'react';

/**
 * Toggle — reusable on/off switch.
 *
 * The thumb position is driven by FLEXBOX justification (justify-start when off,
 * justify-end when on), NOT by `translate`/`transform`. This project runs two
 * atomic-CSS engines at once (Tailwind v4 + a UnoCSS runtime, preset-wind3 =
 * Tailwind v3 semantics); `translate-x-*` resolves differently between them
 * (v4 uses the modern `translate` property with an unset `--tw-translate-y`,
 * v3/UnoCSS uses legacy `transform: translateX`), which pushed the thumb
 * OUTSIDE the track. Flexbox sizing + justification render identically in both.
 *
 * Props:
 *   checked   — boolean
 *   onChange  — () => void, called on activation (skipped when disabled)
 *   disabled  — boolean (default false)
 *   label     — accessible label (aria-label)
 */
const Toggle = ({ checked = false, onChange, disabled = false, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => !disabled && onChange && onChange()}
    className={`inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full p-0.5 transition-colors focus:outline-none focus:ring-2 focus:ring-iris-300 ${
      checked ? 'justify-end bg-iris-600' : 'justify-start bg-slate-300'
    } ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
  >
    <span className="h-4 w-4 flex-shrink-0 rounded-full border border-slate-300 bg-white shadow-sm" />
  </button>
);

export default Toggle;
